import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function initDatasetModes(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DATASET_MODES_FETCH,
    organisationId =>
      requestor
        .get(`${basePath}/organisation/${organisationId}/dataset_mode`, {
          withCredentials: true,
        })
        .then(response => [...response.data]),
  );
}
